import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../component/common/CustomPagination";
import { koKRGrid } from "../../../component/common/TableKRText";
// import SampleDetailDialog from "./SampleDetailDialog"
import api from "../../../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../component/common/SearchBackDrop";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function getKoreaTime(date: Date): Date {
  const koreaOffset = 9 * 60; // 한국은 UTC+9
  const utcTime = date.getTime();
  const koreaTime = new Date(utcTime + koreaOffset * 60000);
  return koreaTime;
}

function getSaturday(date: Date): Date {
  const dayOfWeek = 6; // 토요일
  const currentDate = new Date(date);
  
  while (currentDate.getDay() !== dayOfWeek) {
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return currentDate;
}

function getNextSaturday(date: Date): Date {
  const dayOfWeek = 6; // 토요일
  const currentDate = new Date(date);
  
  while (currentDate.getDay() !== dayOfWeek) {
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  // currentDate.setDate(currentDate.getDate() + 7); // 다음 주 토요일
  currentDate.setDate(currentDate.getDate()); // 다음 주 토요일
  return currentDate;
}

function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function CustomToolbar(props: any) {

  // console.log('CustomToolbar props :::: ' , props)

  const a = new Date();

  const year = a.getFullYear();
  const month = (a.getMonth() + 1).toString().padStart(2, '0'); 
  const day = a.getDate().toString().padStart(2, '0'); 

  // console.log('오늘 날짜' , year + '-'+month + '-'+ day )

  const today = new Date(year + '-'+month + '-'+ day); // 오늘 날짜
  const startDate = new Date('2023-08-19'); // 시작 날짜

  const koreaToday = getKoreaTime(today);
  const saturday = getSaturday(startDate);
  const nextSaturday = getNextSaturday(koreaToday);

  const dateRange: { start: string; end: string }[] = [];
  
  let currentDate = new Date(saturday);
  while (currentDate <= nextSaturday) {
    dateRange.push({
      start: formatDate(currentDate),
      end: formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 6)) // 금요일
    });
    currentDate.setDate(currentDate.getDate() + 7); // 다음 주 토요일
  }

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const ScriptConfirmStatusTable = () => {

  const [page, setPage] = useState(1);

  // const [state, setState] = useState('스크립트제출');
  const [uploadDate, setUploadDate] = useState('');

  const [worker, setWorker] = useState('');

  const [p_uploadDate, setP_uploadDate] = useState('');
  const [p_worker, setP_worker] = useState('');
  const [p_workDate, setP_workDate] = useState('2023-08-19,2023-08-25');

  const setUploadParam = () => {
    setP_uploadDate(uploadDate);
  }

  const setWorkerParam = () => {
    setP_worker(worker);
  }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<any>({
    idx: 0,
    email: "",
    name: "",
    min_ins_date: "",
    max_ins_date: "",
    upload_count: 0,
    confirm_count: 0,
    reject_count: 0,
    total_count: 0
  });
  // api 사용자 정보에서 페이지 정보를 담을 state
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const getScriptConfirmStatus = async () => {
    setBackdrop(true)
    var result = await api.get("/scriptConfirmStatus", {
      params: {email:email}
    });
    console.log("스크립트 검토현황", result.data.datas);
    setBackdrop(false)

    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        idx: idx+1,
        isp_date: data.isp_date,
        isp_email: data.isp_email,
        isp_name: data.isp_name,
        confirm_cnt: data.confirm_cnt,
        reject_cnt: data.reject_cnt,
        total_cnt : (data.confirm_cnt + data.reject_cnt)
      };
    });

    setRows(datas)
    
  };

  useEffect(() => {
    getScriptConfirmStatus();
  }, []);

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const goDetail = (data: any) => {
    console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const columns: GridColDef[] = [
    { field: "idx", headerName: "순번", headerAlign: "center", width: 84,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>순번</Box>
      )
    },
    {
      field: "isp_date", headerName: "검토일자", headerAlign: "center", headerClassName: "header-style", width: 180,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검수일자</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    {
      field: "isp_email", headerName: "이메일", headerAlign: "center", headerClassName: "header-style", width: 180,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이메일</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "isp_name", headerName: "이름", headerAlign: "center", width: 100,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>이름</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "confirm_cnt", headerName: "검토완료", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#1152a7", border: "3px solid #1152a7", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검토완료</Box>
      ),
    },
    { field: "reject_cnt", headerName: "부적합", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#c09c24", border: "3px solid #c09c24", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>부적합</Box>
      ),
    },
    { field: "total_cnt", headerName: "총 건수", headerAlign: "center", width: 200,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#99ca27", border: "3px solid #99ca27", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>총 건수</Box>
      ),
    },
  ];

  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    // console.log('handleSelectionModelChange    id ??? ' , ids)
    console.log('체크박스 idx , ', ids)
    setSelectCheckCnt(ids.length)
    // setSelectedWorkers(ids);
  };

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>현황 - 스크립트 검토</h3></Box>
        <Box sx={{ height: "600px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop/> )}
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                totalCount:totalCount,
                // state: state,
                // setState: setState,
                uploadDate: uploadDate,
                setUploadDate: setUploadDate,
                setUploadParam: setUploadParam,
                selectCheckCnt: selectCheckCnt,
                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,
                p_workDate: p_workDate,
                setP_workDate: setP_workDate,
              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // onFilterModelChange={handleFilterModelChange}
            // sx={{cursor:"pointer"}}
          />
        </Box>
      </ThemeProvider>
      {/* {dialogOpen == true ? (
        <ScriptFileStatusDetailDialog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getScriptFileStatus={getScriptFileStatus}
          // getScriptFileList={getScriptFileList}
        />
      ) : ""} */}
    </Box>
  );
};
export default ScriptConfirmStatusTable;
